module.exports = __webpack_public_path__ + "img/d4.4a9730e0.jpg";